$(function () {
  //スライドショー
  let swiper = new Swiper('.swiper-container', {
    // Optional parameters
    direction: 'horizontal',
    loop: true,
    speed: 800,
    autoplay: {
		delay: 3000,
		disableOnInteraction: true
	},
    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
  });

  // TOP スライドショー
  // サムネ
  const swiper_top_thumb = new Swiper('.top-slide-thumb', {
    spaceBetween: 8,
    slidesPerView: 'auto',
    freeMode: true,
    breakpoints: {
      750: {
        spaceBetween: 16,
      }
    },
    on: {
      slidesUpdated: function() {
        // 中央寄せ
        $('.top-slide-thumb .swiper-wrapper').removeClass('is-updated');
        $('.top-slide-thumb .swiper-wrapper').addClass('is-updated');
      }
    }
  });

  // メイン
  const swiper_top = new Swiper('.top-slide', {
    // Optional parameters
    direction: 'horizontal',
    loop: true,
    loopAdditionalSlides: 2,
    speed: 800,
    autoplay: {
      delay: 3000,
      disableOnInteraction: true
    },
    navigation: {
      nextEl: '.top-slide .swiper-button-next',
      prevEl: '.top-slide .swiper-button-prev',
    },
    thumbs: {
      swiper: swiper_top_thumb,
    },
    breakpoints: {
      750: {
        spaceBetween: 40,
      }
    },
    // // If we need pagination
    // pagination: {
    //   el: '.swiper-pagination',
    //   clickable: true
    // },
  });

  // spのみ
  if (window.matchMedia('(max-width: 749px)').matches) {
    $('.js-mobile-nav-toggle').on('click',function() {
      //$('.mobile-nav-wrapper').fadeToggle();
      $('#PageContainer').toggleClass('menu-open');
    });
    
    $('.site-footer__info h4').on('click',function(){
      $(this).toggleClass('active');
      $(this).next('p').slideToggle(300);
    });
    
    $('.site-footer__content .h4').on('click',function(){
      $(this).toggleClass('active');
      $(this).next('ul').slideToggle(300);
    });
  }
  
  // コレクションタブ切り替え
  $('.js-tab-panel .tab-btn').on('click', function() {
    var tabWrap = $(this).parents('.tab-wrap');
    var tabBtn = tabWrap.find(".tab-btn");
    var tabContents = tabWrap.find('.tab-panel');
    tabBtn.removeClass('active');
    $(this).addClass('active');
    var elmIndex = tabBtn.index(this);
    tabContents.removeClass('active');
    tabContents.eq(elmIndex).addClass('active');
  });
  
  // 商品一覧　並べ替え・絞り込み
  $('.collection-sort-wrap .sort-button').on('click',function(){
    $('.collection-sort-list').not($('.'+$(this).attr('id'))).hide();
	$(this).next('.collection-sort-list').fadeToggle();
  });
  
  // 商品一覧ページネーション
  let show = 12, //最初に表示する件数
      num = 12,  //clickごとに表示したい件数
      contents = '#Collection .grid--view-items .grid__item--collection-template', // 対象のlist
      kosuu = $(contents).length; //全体の件数
  if (show >= kosuu) {
    // 件数全体が指定件数と同じか少ない場合はもっと見るボタンを非表示にする
    $('.collection__more').hide();
  } else {
    // 現在の表示件数を表示
    $('#Collection .end-num').text(show);
  }
  $(contents + ':nth-child(n + ' + (show + 1) + ')').addClass('is-hidden');
  $('.collection__more').on('click', function () {
    $(contents + '.is-hidden').slice(0, num).removeClass('is-hidden');
    let other_num = $(contents + '.is-hidden').length,
        now_num = kosuu - other_num;
    $('#Collection .end-num').text(now_num);
    if ($(contents + '.is-hidden').length == 0) {
      $('.collection__more').fadeOut();
    }
  });
  
  // スムーズスクロール
  $('a[href^="#"]').click(function(){
    let adjust = 0,
        speed = 400,
        href= $(this).attr("href"),
        target = $(href == "#" || href == "" ? 'html' : href),
        position = target.offset().top + adjust;
    $('body,html').animate({scrollTop:position}, speed, 'swing');
    return false;
  });
  
  // 個数をプラス/マイナスボタンで変更する
  $('.btn-minus').on('click', function(e) {
    let input = $(e.target).closest('.product-item__num').find('input');
    input[0]['stepDown']();
  });
  $('.btn-plus').on('click', function(e) {
    let input = $(e.target).closest('.product-item__num').find('input');
    input[0]['stepUp']();
  });
  
  // よくあるご質問
  $('.faq dt').on('click',function(){
    $(this).toggleClass('active');
    $(this).next('dd').slideToggle(300);
  });
  
  
  // 住所追加
  $('#AddressNewButton').on('click', function() {
    $('#AddressNewForm').toggleClass('hide');
  });
  

  // 住所変更
  document.querySelectorAll('.address-edit-toggle').forEach(function(button) {
    button.addEventListener('click', function(evt) {
      var formId = evt.target.dataset.formId;
      var editButton = document.getElementById('EditFormButton_' + formId);
      var editAddress = document.getElementById('EditAddress_' + formId);
      var isExpanded = editButton.getAttribute('aria-expanded') === 'true';
      
      editAddress.classList.toggle('hide');
      editButton.setAttribute('aria-expanded', !isExpanded);
      editButton.focus();
    });
  });
  
  document.querySelectorAll('.address-delete').forEach(function(button) {
    button.addEventListener('click', function(evt) {
      var target = evt.target.dataset.target;
      var confirmMessage = evt.target.dataset.confirmMessage;
      
      // eslint-disable-next-line no-alert
      if (
        confirm(
          confirmMessage || 'Are you sure you wish to delete this address?'
        )
      ) {
        Shopify.postLink(target, {
          parameters: { _method: 'delete' }
        });
      }
    });
  });
  
  // 固定ヘッダー
  let startPos = 0,
    winScrollTop = 0;
  $(window).on('scroll',function(){
    winScrollTop = $(this).scrollTop();
    if (window.matchMedia('(min-width: 750px)').matches) { //PC
      if(winScrollTop >= 147){
        $('.site-header').addClass('header-fixed');
        $('#PageContainer').addClass('header-fixed');
        } else {
        $('.site-header').removeClass('header-fixed');
        $('#PageContainer').removeClass('header-fixed');
        }
      
      if (winScrollTop >= startPos) {
        if(winScrollTop >= 147){
          $('.site-header').addClass('header-hide');
          }
        } else {
        $('.site-header').removeClass('header-hide');
        }
      }
    startPos = winScrollTop;
  });


  // ログインフォーム（パスワードをお忘れの方）
  $('#RecoverPassword').on('click', function(e) {
    e.preventDefault();
    $('#RecoverPasswordForm').removeClass('hide');
    $('#CustomerLoginForm').addClass('hide');
  });

  $('#HideRecoverPasswordLink').on('click', function(e) {
    e.preventDefault();
    $('#RecoverPasswordForm').addClass('hide');
    $('#CustomerLoginForm').removeClass('hide');
  });

  $('#RecoverEmail').on('blur', function(){
    if($(this).val() == ""){
      alert('メールアドレスを入力して下さい。');
      return false;
    } else {
      $('#PasswordSubmit').prop('disabled', false);
    }
  });
  
  $('#PasswordSubmit').on('click', function() {
    $('#RecoverPasswordForm').addClass('hide');
    $('#ThanksMessage').removeClass('hide');
  });

  // 会員登録（生年月日）
  $(function() {

    // 選択された年月日を取得
    var selected_year = $('#RegisterForm-year').val;
    var selected_month = $('#RegisterForm-month').val;
    var selected_day = $('#RegisterForm-day').val;

    // 選択された年・月に合わせて、適した日の値を選択肢にセットする
    $('#RegisterForm-year, #RegisterForm-month').change(function() {
      selected_year = $('#RegisterForm-year').val();
      selected_month = $('#RegisterForm-month').val();
      selected_day = $('#RegisterForm-day').val();

        // 各月ごとの最終日を判定

            // 2月：日の選択肢は1~28日に設定
            // ※ ただし、閏年の場合は29日に設定
            if (selected_month == 2) {
                if((Math.floor(selected_year%4 == 0)) && (Math.floor(selected_year%100 != 0)) || (Math.floor(selected_year%400 == 0))){
                    last_date = 29;

                  if(selected_day == 30 || selected_day == 31) {
                    selected_day = 29;
                  }
                  
                } else {
                  last_date = 28;

                  if(selected_day == 29 || selected_day == 30 || selected_day == 31) {
                    selected_day = 28;
                  }

                }

            // 4, 6, 9, 11月：日の選択肢は1~30日に設定
            }else if(selected_month == 4 || selected_month == 6 || selected_month == 9 || selected_month == 11 ){
                last_date = 30;
              
                if(selected_day == 31) {
                  selected_day = 30;
                }

            // 1, 3, 5, 7, 8, 10, 12月：日の選択肢は1~31日に設定
            }else{
                last_date = 31;
            }

      
        $('#RegisterForm-day').children('option').remove();
        $('#RegisterForm-day').append('<option value="' + 0 + '">---</option>');
        for (var m = 1; m <= last_date; m++) {
          if(m == selected_day) {
            $('#RegisterForm-day').append('<option value="' + m + '" selected>' + m + '</option>');
          } else {
            $('#RegisterForm-day').append('<option value="' + m + '">' + m + '</option>');
          }
        }
      
    });


  });


  

  
});